// const selectors = {
//   block: "[data-pf]",
//   filterForm: "[data-pf-filters]",
//   filter: "[data-pf-filter]",
// };

// const initBlock = (block) => {
//   const searchParams = new URLSearchParams(window.location.search);
//   const queryCategory = searchParams.getAll("category");

//   const filterForm = block.querySelector(selectors.filterForm);
//   const filters = block.querySelectorAll(selectors.filter);

//   filters?.forEach((filter) => {
//     filter.classList[queryCategory.includes(filter.value) ? "add" : "remove"]("active");

//     filter.addEventListener("click", () => {
//       filterForm.submit();
//     });
//   });
// };

// document.addEventListener(
//   "DOMContentLoaded",
//   async function () {
//     const blocks = document.querySelectorAll(selectors.block);

//     blocks?.forEach(initBlock);
//   },
//   {
//     once: true,
//   }
// );

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

const selectors = {
  block: "[data-pf]",
  filterForm: "[data-pf-filters]",
  filter: "[data-pf-filter]",
  slider: "[data-pf-slider]",
};

const initSlider = (block) => {
  const slider = block.querySelector(selectors.slider);
  if (!slider) return;

  Swiper.use([Navigation, Pagination]);

  // new Swiper(slider, {
  //   spaceBetween: 16,

  //   breakpoints: {
  //     0: {
  //       slidesPerView: 1,
  //       slidesPerGroup: 1,
  //     },
  //     640: {
  //       slidesPerView: 2,
  //       slidesPerGroup: 2,
  //     },
  //     1024: {
  //       slidesPerView: 3,
  //       slidesPerGroup: 3,
  //     },
  //     1280: {
  //       slidesPerView: 4,
  //       slidesPerGroup: 4,
  //     },
  //   },
  //   navigation: {
  //     prevEl: block.querySelector('[data-swiper-navigation="prev"]'),
  //     nextEl: block.querySelector('[data-swiper-navigation="next"]'),
  //   },

  //   pagination: {
  //     el: block.querySelector('[data-swiper-pagination]'),
  //   },
  // });

  new Swiper(slider, {
    spaceBetween: 32,
    slidesPerView: "auto",
    slideToClickedSlide: false,
    watchOverflow: true,

    navigation: {
      prevEl: block.querySelector('[data-swiper-navigation="prev"]'),
      nextEl: block.querySelector('[data-swiper-navigation="next"]'),
      hideOnClick: false,
      disabledClass: "hidden",
    },

    pagination: {
      el: block.querySelector("[data-swiper-pagination]"),
    },
  });
};

const initBlock = (block) => {
  const searchParams = new URLSearchParams(window.location.search);
  const queryCategory = searchParams.getAll("category");

  const filterForm = block.querySelector(selectors.filterForm);
  const filters = block.querySelectorAll(selectors.filter);

  filters?.forEach((filter) => {
    filter.classList[queryCategory.includes(filter.value) ? "add" : "remove"]("active");

    filter.addEventListener("click", () => {
      filterForm.submit();
    });
  });

  initSlider(block);
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);
    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);
